import type { AccountNumberDto, ReturnHubLink } from '@dhl/mdp-api'
import { type Account, inverseSelectedProducts } from '~/common/components/accountnumbers'
import { getProductsByAccountType, isProductConfigurable, type Product } from '~/common/model/capabilities'

export const toAccountNumberDto = (
  allProducts: Product[],
  { id, accountType, organisationId, selectedProducts, selectedShipmentOptions, countryCode }: Account
): AccountNumberDto => {
  const returnHubLinks: ReturnHubLink[] = selectedProducts.reduce((acc, product) => {
    const { returnHubId, locationId, additionalCustomerInformation, value } = product
    const hasReturnHubLink = isProductConfigurable(product) && (!!returnHubId || !!locationId)
    return hasReturnHubLink
      ? acc.concat({
          returnProductCode: value,
          accountNumber: id,
          locationId,
          returnHubId,
          additionalCustomerInformation,
        } as ReturnHubLink)
      : acc
  }, [] as ReturnHubLink[])

  return {
    id,
    accountType,
    organisationId,
    countryCode,
    productBlacklist: inverseSelectedProducts(selectedProducts, getProductsByAccountType(accountType, allProducts)).map(
      (p) => p.value
    ),
    parcelTypeBlacklist: [],
    optionWhitelist: selectedShipmentOptions,
    returnHubLinks: returnHubLinks.length > 0 ? returnHubLinks : undefined,
  }
}
